import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// pages
import login from "./pages/login.vue";
import imgModify from "./pages/imgModify.vue";
import myProfile from "./pages/myProfile.vue";
import orderList from "./pages/orderList.vue";
import productList from "./pages/productList.vue";
import textModify from "./pages/textModify.vue";
import shopList from "./pages/shopList.vue";
import userList from "./pages/userList.vue";
import categoriesList from "./pages/categoriesList.vue";
import specialCate from "./pages/specialCate.vue";
import adModify from "./pages/adModify.vue";
import banDate from "./pages/banDate.vue";
import areaList from "./pages/areaList.vue";
import banPhone from "./pages/banPhone.vue";
import orderRestriction from "./pages/orderRestriction.vue";
import driverList from "./pages/driverList.vue";
import orderTotal from "./pages/orderTotal.vue";  //修改
import carList from "./pages/carList.vue";
import test from "./pages/test.vue";
import member from "./pages/member.vue";
import lottery from "./pages/lottery.vue";
import couponList from "./pages/couponList.vue";


import axios from 'axios'
import VueAxios from 'vue-axios'
import md5 from 'js-md5'

import JsonExcel from 'vue-json-excel'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.component('downloadExcel', JsonExcel)

Vue.use(VueRouter)
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueAxios, axios)
Vue.use(require('vue-moment'));
Vue.prototype.$md5 = md5;

Vue.prototype.$urlGlobal = "https://freshgo.top/api/public/api/v1/"
// Vue.prototype.$urlGlobal = "http://freshgo123.com/api/public/api/v1/"



const router = new VueRouter({

  routes: [
    // dynamic segments start with a colon
    {
      path: '/login',
      component: login
    },
    {
      path: '/member',
      component: member
    },
    {
      path: '/textModify',
      component: textModify
    },
    {
      path: '/imgModify',
      component: imgModify
    },
    {
      path: '/myProfile',
      component: myProfile
    },
    {
      path: '/orderList',
      component: orderList
    },
    {
      path: '/productList',
      component: productList
    },
    {
      path: '/shopList',
      component: shopList
    },
    {
      path: '/userList',
      component: userList
    },
    {
      path: '/categoriesList',
      component: categoriesList
    },
    {
      path: '/specialCate',
      component: specialCate
    },
    {
      path: '/adModify',
      component: adModify
    },
    {
      path: '/banDate',
      component: banDate
    },
    {
      path: '/banPhone',
      component: banPhone
    },
    {
      path: '/areaList',
      component: areaList
    },
    {
      path: '/orderRestriction',
      component: orderRestriction
    },
    {
      path: '/driverList',
      component: driverList
    },
    {
      path: '/carList',
      component: carList
    },
    {
      path: '/lottery',
      component: lottery
    },
    {
      path: '/couponList',
      component: couponList
    },
    {
      path: '/test',
      component: test
    },
    {
      path: '/orderTotal',    //修改
      component: orderTotal
    },

  ]
})

new Vue({
  router,
  render: h => h(App),
  methods: {

  },
  mounted: function () {
    // var temp = localStorage.getItem("auth");
    // if (temp == undefined) {
    //   this.$router.push("/login");
    //   return;
    // }
  }
}).$mount('#app')
